import { preserveSelection } from 'common/Prose/utils/selection'
import { NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'

export const setTextColor = (color: string, view: EditorView) => {
  const { selection, tr, schema } = view.state
  const { empty } = selection
  let { ranges } = selection

  if (selection instanceof NodeSelection && 'fontColor' in selection.node.attrs) {
    tr.setNodeMarkup(selection.$from.pos, undefined, {
      ...selection.node.attrs,
      fontColor: color,
    })
  } else if (empty) {
    // Upsert stored mark
    tr.removeStoredMark(schema.marks.colored)
    tr.addStoredMark(schema.marks.colored.create({ color }))

    if (color.startsWith('linear-gradient')) {
      tr.removeStoredMark(schema.marks.highlighted)
    }
  } else {
    ranges.forEach((range) => {
      const { $from, $to } = range,
        from = $from.pos,
        to = $to.pos

      if (color.startsWith('linear-gradient')) {
        tr.removeMark(from, to, schema.marks.highlighted)
      }

      view.state.doc.nodesBetween(from, to, (node, pos) => {
        const codeMark = schema.marks.code.isInSet(node.marks)
        const endPos = Math.min(to, pos + node.nodeSize)

        if (node.isText && !codeMark) {
          tr.addMark(Math.max(pos, from), endPos, schema.marks.colored.create({ color }))
        }
      })

      preserveSelection(tr, view.state)
    })
  }

  view.dispatch(tr.scrollIntoView())
  view.focus()
}

export const removeTextColor = (view: EditorView) => {
  const { empty, ranges } = view.state.selection
  const { tr, schema } = view.state

  if (empty) {
    tr.removeStoredMark(schema.marks.colored)
  } else {
    ranges.forEach((range) => {
      const { $from, $to } = range,
        from = $from.pos,
        to = $to.pos

      tr.removeMark(from, to, schema.marks.colored)

      preserveSelection(tr, view.state)
    })
  }

  view.dispatch(tr)
  view.focus()
}
